// useInformationDensity — maps the current semantic zoom level to visibility flags.
// Controls what detail is shown/hidden at different zoom levels.

import { useSelector } from "react-redux";
import { selectZoomLevel } from "../../store/slices/canvasSlice.ts";

export interface InformationDensity {
  showNodeLabels: boolean;
  showConnectionLabels: boolean;
  showRelationshipPills: boolean;
  showClassificationBadges: boolean;
}

export function useInformationDensity(): InformationDensity {
  const zoomLevel = useSelector(selectZoomLevel);

  switch (zoomLevel) {
    case "ecosystem":
      return {
        showNodeLabels: false,
        showConnectionLabels: false,
        showRelationshipPills: false,
        showClassificationBadges: false,
      };
    case "context":
      return {
        showNodeLabels: true,
        showConnectionLabels: true,
        showRelationshipPills: false,
        showClassificationBadges: true,
      };
    case "element":
      return {
        showNodeLabels: true,
        showConnectionLabels: true,
        showRelationshipPills: true,
        showClassificationBadges: true,
      };
  }
}
